import React, { useEffect, useState } from 'react';

export default function  FadeIn ({ children, duration = 500, ease_function = 'ease-in-out' })  {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setIsVisible(true);
        }, duration);

        return () => clearTimeout(timeoutId);
    }, [duration]);

    return (
        <div
            style={{ 
                opacity: isVisible ? 1 : 0,
                transition: `opacity ${duration}ms ${ease_function}` }}>
            {children}
        </div>
    );
};
